import React, { FC, useCallback, useEffect } from 'react'

import ChangePasswordUserProfile from '../user-profile/components/change-password/change-password-user-profile'
import * as Models from '../../api/model/models'
import { accountActions } from '../../store/slices/accountSlice'
import { useAppDispatch, useAppSelector } from '../../store/store'
import { PASSWORD_EXPIRED_EVENT } from '../../utils/password-expiration'

type UserWithPasswordExpiration = {
  passwordExpired?: boolean
  password_expired?: boolean
}

const PASSWORD_EXPIRED_MESSAGE =
  'Срок действия вашего пароля истек, для продолжения введите текущий пароль, новый пароль и повтор нового пароля.'

const PasswordExpiredModal: FC = () => {
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.account.user) as
    | (Models.UserWSGetPrivate & UserWithPasswordExpiration)
    | undefined
  const passwordExpired = useAppSelector((state) => state.account.passwordExpired)
  const visible = passwordExpired || (!!user && (user.passwordExpired === true || user.password_expired === true))

  useEffect(() => {
    const handlePasswordExpired = () => {
      dispatch(accountActions.setPasswordExpired(true))
    }

    window.addEventListener(PASSWORD_EXPIRED_EVENT, handlePasswordExpired)
    return () => window.removeEventListener(PASSWORD_EXPIRED_EVENT, handlePasswordExpired)
  }, [dispatch])

  const reloadPage = useCallback(() => {
    window.location.reload()
  }, [])

  const logout = useCallback(async () => {
    await dispatch(accountActions.fetchLogOut())
    window.location.reload()
  }, [dispatch])

  return (
    <ChangePasswordUserProfile
      visibleForm={visible}
      onCloseForm={logout}
      description={PASSWORD_EXPIRED_MESSAGE}
      isRequiredPasswordChange
      onSuccess={reloadPage}
    />
  )
}

export default PasswordExpiredModal
